var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top",style:(_vm.BlueListincludes?'color:var( --text-color);':'')},[_c('van-icon',{staticStyle:{"transform":"rotate(90deg)"},attrs:{"name":"down"},on:{"click":function($event){return _vm.toprouter()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }